import { useEffect, useMemo } from 'react';
import { useAuthStore } from '../store/authStore';
import { useBabiesStore } from '../store/babiesStore';
import { useVariationCatalog } from './useVariationCatalog';
import { BabySizeMatch, matchBabiesToOptions } from '../utils/babyAge';
import { AGE_VARIATION_TYPE } from '../utils/variantResolution';

export function useBabySizeMatches(): BabySizeMatch[] {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const customerId = useAuthStore((s) => s.customerId);
  const babies = useBabiesStore((s) => s.babies);
  const ownerId = useBabiesStore((s) => s.ownerId);
  const ensureLoaded = useBabiesStore((s) => s.ensureLoaded);
  const { types } = useVariationCatalog();

  useEffect(() => {
    if (isAuthenticated && customerId !== null) ensureLoaded(customerId);
  }, [isAuthenticated, customerId, ensureLoaded]);

  return useMemo(() => {
    if (!isAuthenticated || customerId === null || ownerId !== customerId) return [];
    const ageType = types.find((t) => t.id === AGE_VARIATION_TYPE);
    return ageType ? matchBabiesToOptions(babies, ageType.options) : [];
  }, [isAuthenticated, customerId, ownerId, babies, types]);
}
